import { useDevice } from '@/hooks/useDevice'
import { useSystemConfigStore } from '@/stores/systemConfig'
// vite 会在构建时处理这些静态资源
const images = import.meta.glob('@/assets/images/influenbase-*', { eager: true, import: 'default' })
let imagesMap = new Map()
function handleImageMap() {
  for (const key in images) {
    let imgName = key.split('/').pop()
    imagesMap.set(imgName, images[key])
  }
}
handleImageMap()

export const getImage = (url: string) => {
  let imgName = url.split('/').pop()
  return imagesMap.get(imgName)
}

const { isMobile } = useDevice()
export function resize() {
  let dom = document
  let width = isMobile ? 750 : 1920
  let fs = dom.body.clientWidth / (width / 16)

  // if (dom.body.clientWidth < 1660) {
  //   // 👇注意这里不能直接document.body.style
  //   dom.body.parentNode && (dom.body.parentNode.style = "font-size: 14px;");
  // } else {
  // 👇注意这里不能直接document.body.style

  dom.body.parentNode && (dom.body.parentNode.style = 'font-size: ' + fs + 'px;')
  // }
}

// 不知道是啥
export function getConfig(md: string) {
  const systemStore = useSystemConfigStore()
  let configInfo = systemStore.baseUrl
  let configInfoCase = configInfo.find((item) => item.configKey == md) || {
    configValue: '',
  }
  return configInfoCase.configValue
}

// 不知道是啥
export function getInfoKey(data) {
  const systemStore = useSystemConfigStore()
  let baseURL = systemStore.baseUrl
  return baseURL.filter((item) => item.configKey == data) || []
}

// 不知道是啥
export function getInfoKeyValue(data) {
  const systemStore = useSystemConfigStore()
  let configInfo = systemStore.baseUrl
  let configInfoCase = configInfo.find((item) => item.configKey == data) || {
    configValue: '',
  }
  return configInfoCase.configValue
}

// 不知道是啥
export function urlRegex(url) {
  const regex = /^https?:\/\/.*?\/(.*)$/
  const match = url.match(regex)

  let thirdSegment = ''
  if (match) {
    return (thirdSegment = '/' + match[1])
  } else {
    return ''
  }
}
